import React, { useState } from "react";
import { FaFingerprint } from "react-icons/fa";
import Accordion from 'react-bootstrap/Accordion';
import { FaAngleUp } from "react-icons/fa";
import ButtonList from "../ButtonList/ButtonList";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { IoClose } from "react-icons/io5";
import SupportPopup from "../SupportPopup/SupportPopup";

function LessonRates() {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    return (
        <>

            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className="center-form-modal"
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <h3 className="text mb-5">How can we help?</h3>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <SupportPopup />
                </Modal.Body>
            </Modal>


            <section id="lesson_rate" className="lesson_rate bg_dark page-section">
                <div className="container-xl">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <h2 className="sec_title">Lesson Rates</h2>
                        <div className="btn-section hide_mobile">
                            <ButtonList />
                        </div>
                    </div>
                    <div className="row hide_mobile_f">
                        <div className="col-lg-4 w_1280">
                            <div className="gs_b gs_fr">
                                <div className="gs_fr_top">
                                    <div className="gab_title">
                                        <div className="gab_icon">
                                            <FaFingerprint />
                                        </div>
                                        <div className="gab_text text-left">
                                            <h5>Foundation Plan</h5>
                                            <small>Instruction </small>
                                        </div>
                                    </div>
                                    <div className="gs_fr_text">
                                        <p>
                                            Develop a solid foundation of skills in all areas of the game.
                                        </p>
                                        <a className="link-icon" href="#"> 4 lessons by appointment</a>
                                    </div>
                                    <a href="#" className="btn btn_default bg-white text-dark show_1280 show_mobile_tab gs_fr_action" onClick={handleShow}>Four Lessons <strong>$499</strong></a>
                                </div>
                                <div id="outer" className="marquee-5872 outer">
                                    <ul id="tick" className="gs_fr_list">
                                        <li className><i className="bi bi-check" /> Learn the driver swing</li>
                                        <li className><i className="bi bi-check" /> Learn how to hit irons</li>
                                        <li className><i className="bi bi-check" /> Learn short game basics</li>
                                        <li className><i className="bi bi-check" /> Learn putting essentials</li>
                                    </ul>
                                </div>
                                <div className="marquee-wrapper slider-5872">
                                    <div className>
                                        <div className="marquee-block marquee-block1">
                                            <div className="marquee-inner to-left">
                                                <span>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Learn the driver swing</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn how to hit irons</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn short game basics</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn putting essentials</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Learn the driver swing</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn how to hit irons</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn short game basics</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn putting essentials</p>
                                                    </div>
                                                </span>
                                                <span>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Learn the driver swing</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn how to hit irons</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn short game basics</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn putting essentials</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Learn the driver swing</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn how to hit irons</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn short game basics</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn putting essentials</p>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <a className="btn btn_default bg-white text-dark gs_fr_action hide_1280 hide_tab" onClick={handleShow}>Four Lessons <strong>$499</strong></a>
                            </div>
                        </div>
                        <div className="col-lg-4 w_1280">
                            <div className="gs_b gs_fr">
                                <div className="gs_fr_top">
                                    <div className="gab_title">
                                        <div className="gab_icon">
                                            <FaFingerprint />
                                        </div>
                                        <div className="gab_text">
                                            <h5>Technique Plan</h5>
                                            <small>Instrictions </small>
                                        </div>
                                    </div>
                                    <div className="gs_fr_text">
                                        <p>
                                            Find your oprtimal match up and learn proper movement.
                                        </p>
                                        <a className="link-icon" href="#">8 lessons by appointment</a>
                                    </div>
                                    <a className="btn btn_default bg-white text-dark show_1280 show_mobile_tab gs_fr_action" onClick={handleShow}>Eight Lessons <strong>$999</strong></a>
                                </div>
                                <div id="outer" className="marquee-5872">
                                    <ul id="tick" className="gs_fr_list">
                                        <li className><i className="bi bi-check" /> Develop a match up</li>
                                        <li className><i className="bi bi-check" /> Create a shot shape</li>
                                        <li className><i className="bi bi-check" /> Refine your short game</li>
                                        <li className><i className="bi bi-check" /> Consistency in putting</li>
                                    </ul>
                                </div>
                                <div className="marquee-wrapper slider-5872">
                                    <div className>
                                        <div className="marquee-block marquee-block2">
                                            <div className="marquee-inner to-left">
                                                <span>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Develop a match up</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Create a shot shape</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Refine your short game</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Consistency in putting</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Develop a match up</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Create a shot shape</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Refine your short game</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Consistency in putting</p>
                                                    </div>
                                                </span>
                                                <span>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Develop a match up</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Create a shot shape</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Refine your short game</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Consistency in putting</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Develop a match up</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Create a shot shape</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Refine your short game</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Consistency in putting</p>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <a className="btn btn_default bg-white text-dark gs_fr_action hide_1280 hide_tab" onClick={handleShow}>Eight Lessons <strong>$999</strong></a>
                            </div>
                        </div>
                        <div className="col-lg-4 w_1280">
                            <div className="gs_b gs_fr">
                                <div className="gs_fr_top">
                                    <div className="gab_title">
                                        <div className="gab_icon">
                                            <FaFingerprint />
                                        </div>
                                        <div className="gab_text">
                                            <h5>Scoring Plan</h5>
                                            <small>Instruction</small>
                                        </div>
                                    </div>
                                    <div className="gs_fr_text">
                                        <p>
                                            Become a complete player that can score anywhere.
                                        </p>
                                        <a className="link-icon" href="#">12 lessons by appointment</a>
                                    </div>
                                    <a className="btn btn_default bg-white text-dark show_1280 show_mobile_tab gs_fr_action" onClick={handleShow}>Twelve Lessons <strong>$1499</strong></a>
                                </div>
                                <div id="outer" className="marquee-5872">
                                    <ul id="tick" className="gs_fr_list">
                                        <li className><i className="bi bi-check" /> Increase speed + distance</li>
                                        <li className><i className="bi bi-check" /> Learn multiple shot shapes</li>
                                        <li className><i className="bi bi-check" /> Creativity around the green</li>
                                        <li className><i className="bi bi-check" /> Reading greens and lies</li>
                                    </ul>
                                </div>
                                <div className="marquee-wrapper slider-5872">
                                    <div className>
                                        <div className="marquee-block marquee-block3">
                                            <div className="marquee-inner to-left">
                                                <span>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Increase speed + distance</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn multiple shot shapes</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Creativity around the green</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Reading greens and lies</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Increase speed + distance</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn multiple shot shapes</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Creativity around the green</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Reading greens and lies</p>
                                                    </div>
                                                </span>
                                                <span>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Increase speed + distance</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn multiple shot shapes</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Creativity around the green</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" /> Reading greens and lies</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Increase speed + distance</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Learn multiple shot shapes</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Creativity around the green</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Reading greens and lies</p>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <a className="btn btn_default bg-white text-dark gs_fr_action hide_1280 hide_tab" onClick={handleShow}>Twelve Lessons <strong>$1499</strong></a>
                            </div>
                        </div>
                    </div>
                    <Accordion>
                        <div className="row show_mobile">
                            <div className="col-lg-4">
                                <Accordion.Item eventKey="0" className="mobile-accordion">
                                    <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                        <div className="gs_fr_top" id="lesson_card_1">
                                            <Accordion.Header>
                                                <div className="gab_title">
                                                    <div className="gab_text text-left">
                                                        <h5>Foundation Plan</h5>
                                                        <small>Instruction </small>
                                                    </div>
                                                    <div className="collapsed">
                                                        <div className="gab_icon ">
                                                            <FaAngleUp />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                        </div>
                                        <Accordion.Body>
                                            <div className="gs_fr_text">
                                                <p>
                                                    Develop a solid foundation of skills in all areas of the game.
                                                </p>
                                                <a className="link-icon" href="#"> 4 lessons by appointment</a>
                                            </div>
                                            <ul className="gs_fr_list">
                                                <li className><i className="bi bi-check" /> Learn the driver swing</li>
                                                <li className><i className="bi bi-check" /> Learn how to hit irons</li>
                                                <li className><i className="bi bi-check" /> Learn short game basics</li>
                                                <li className><i className="bi bi-check" /> Learn putting essentials</li>
                                            </ul>
                                            <a className="btn btn_default bg-white text-dark gs_fr_action" onClick={handleShow}>Four lessons <strong>$499</strong></a>
                                        </Accordion.Body>
                                    </div>
                                </Accordion.Item>
                            </div>
                            <div className="col-lg-4">
                                <Accordion.Item eventKey="1" className="mobile-accordion">
                                    <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                        <div className="gs_fr_top" id="lesson_card_1">
                                            <Accordion.Header>
                                                <div className="gab_title">
                                                    <div className="gab_text">
                                                        <h5>Technique Plan</h5>
                                                        <small>Instrictions </small>
                                                    </div>
                                                    <div className="collapsed">
                                                        <div className="gab_icon ">
                                                            <FaAngleUp />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                        </div>
                                        <Accordion.Body>
                                            <div className="gs_fr_text">
                                                <p>
                                                    Find your oprtimal match up and learn proper movement.
                                                </p>
                                                <a className="link-icon" href="#"> 8 lessons by appointment</a>
                                            </div>
                                            <ul className="gs_fr_list">
                                                <li className><i className="bi bi-check" /> Develop a match up</li>
                                                <li className><i className="bi bi-check" /> Create a shot shape</li>
                                                <li className><i className="bi bi-check" /> Refine your short game</li>
                                                <li className><i className="bi bi-check" /> Consistency in putting</li>
                                            </ul>
                                            <a className="btn btn_default bg-white text-dark gs_fr_action" onClick={handleShow}>Eight lessons <strong>$999</strong></a>
                                        </Accordion.Body>
                                    </div>
                                </Accordion.Item>
                            </div>
                            <div className="col-lg-4">
                                <Accordion.Item eventKey="2" className="mobile-accordion">
                                    <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                        <div className="gs_fr_top" id="lesson_card_1">
                                            <Accordion.Header>
                                                <div className="gab_title">
                                                    <div className="gab_text">
                                                        <h5>Scoring Plan</h5>
                                                        <small>Instruction</small>
                                                    </div>
                                                    <div className="collapsed">
                                                        <div className="gab_icon ">
                                                            <FaAngleUp />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                        </div>
                                        <Accordion.Body>
                                            <div className="gs_fr_text">
                                                <p>
                                                    Become a complete player that can score anywhere.
                                                </p>
                                                <a className="link-icon" href="#"> 12 lessons by appointment</a>
                                            </div>
                                            <ul className="gs_fr_list">
                                                <li className><i className="bi bi-check" /> Increase speed + distance</li>
                                                <li className><i className="bi bi-check" /> Learn multiple shot shapes</li>
                                                <li className><i className="bi bi-check" /> Creativity around the green</li>
                                                <li className><i className="bi bi-check" /> Reading greens and lies</li>
                                            </ul>
                                            <a className="btn btn_default bg-white text-dark gs_fr_action" onClick={handleShow}>Twelve lessons <strong>$1499</strong></a>
                                        </Accordion.Body>
                                    </div>
                                </Accordion.Item>
                            </div>
                        </div>
                    </Accordion>
                    <div className="btn-section hide_desktop-v2">
                        <ButtonList />
                    </div>
                </div>
            </section>

        </>
    );
}

export default LessonRates;